import React from 'react';

import Styled from './ButtonWithIconStyled';

interface ButtonWithIconInterface {
  icon: string | JSX.Element;
  href?: string;
  as?: string;
  rel?: string;
  target?: string;
  download?: boolean;
  id?: string;
  title?: string;
  onClick?: Function;
}

const ButtonWithIcon: React.FC<ButtonWithIconInterface> = (
  props,
): JSX.Element => {
  return (
    // @ts-ignore
    <Styled.Wrapper {...props}>
      <Styled.Icon>{props.icon}</Styled.Icon>
      <Styled.Label size="action">{props.children}</Styled.Label>
    </Styled.Wrapper>
  );
};

export default ButtonWithIcon;
